/* eslint-disable */

/**
 * * Describes the domain type of the sync entity and what the sync entity's intended purpose is.
 * This can be used to make targeted queries and filter based on domain type.
 * This is different than SyncEntity.Type which currently describes the sync entity schema not the
 * actual data content type. For example, SyncEntity.Type PAYMENT today does not actually always
 * represent a payment, it just uses the payment schema.
 */
export enum DomainType {
  DO_NOT_USE_DOMAIN_TYPE = "DO_NOT_USE_DOMAIN_TYPE",
  GLOBAL_INVEST_NOTIFICATION_SETTINGS = "GLOBAL_INVEST_NOTIFICATION_SETTINGS",
  AVAILABLE_CUSTOMER_ACCOUNT_STATEMENTS = "AVAILABLE_CUSTOMER_ACCOUNT_STATEMENTS",
  LIGHTNING_WITHDRAWAL = "LIGHTNING_WITHDRAWAL",
  CRYPTO_PAYMENT_CUSTOMER = "CRYPTO_PAYMENT_CUSTOMER",
  INVESTMENT_CORPORATE_ACTION = "INVESTMENT_CORPORATE_ACTION",
  CHECK_DEPOSIT = "CHECK_DEPOSIT",
  CHECK_DEPOSIT_V2 = "CHECK_DEPOSIT_V2",
  INVEST_CRYPTO_ORDER = "INVEST_CRYPTO_ORDER",
  INVESTMENT_DIVIDEND = "INVESTMENT_DIVIDEND",
  LIBRARIAN_DOCUMENT = "LIBRARIAN_DOCUMENT",
  GIFT_CARD = "GIFT_CARD",
  GIFT_CARD_PAYMENT = "GIFT_CARD_PAYMENT",
  GRANT = "GRANT",
  HOLDING_ENTITY = "HOLDING_ENTITY",
  BTC_PAYMENT = "BTC_PAYMENT",
  INVEST_P2P_PAYMENT = "INVEST_P2P_PAYMENT",
  INSTANT_PAY_SETTLEMENT = "INSTANT_PAY_SETTLEMENT",
  LOAN_TRANSACTION_ACTIVITY = "LOAN_TRANSACTION_ACTIVITY",
  NEW_DEVICE_LOGINS = "NEW_DEVICE_LOGINS",
  INVESTMENT_ORDER = "INVESTMENT_ORDER",
  PENDING_REFERRAL = "PENDING_REFERRAL",
  PAPER_MONEY_DEPOSIT = "PAPER_MONEY_DEPOSIT",
  PAYMENT_SCHEDULE = "PAYMENT_SCHEDULE",
  PAY_WITH_CASH_PAYMENT = "PAY_WITH_CASH_PAYMENT",
  PAY_WITH_CASH_REFUND = "PAY_WITH_CASH_REFUND",
  RECEIPT = "RECEIPT",
  RECURRING_PREFERENCE = "RECURRING_PREFERENCE",
  SPONSORED_ACCOUNT_ACTIVITY = "SPONSORED_ACCOUNT_ACTIVITY",
  CASH_HOUSE_SCREEN = "CASH_HOUSE_SCREEN",
  SELECTED_REWARD = "SELECTED_REWARD",
  TRANSFER = "TRANSFER",
  CRYPTO_PAYROLL_PREFERENCE = "CRYPTO_PAYROLL_PREFERENCE",
  INVESTMENT_CATEGORY = "INVESTMENT_CATEGORY",
  INVESTMENT_ENTITY_RANKING = "INVESTMENT_ENTITY_RANKING",
  INVESTMENT_FILTER_GROUP = "INVESTMENT_FILTER_GROUP",
  INVESTMENT_ENTITY = "INVESTMENT_ENTITY",
  INVESTMENT_INCENTIVE = "INVESTMENT_INCENTIVE",
  INVITATION = "INVITATION",
  /** @deprecated */
  LENDING_CREDIT_LINE = "LENDING_CREDIT_LINE",
  /** @deprecated */
  LENDING_LOAN = "LENDING_LOAN",
  CREDIT_LINE = "CREDIT_LINE",
  LOAN_TRANSACTION_DATA = "LOAN_TRANSACTION_DATA",
  LOYALTY_ACCOUNT = "LOYALTY_ACCOUNT",
  LOYALTY_PROGRAM = "LOYALTY_PROGRAM",
  LOYALTY_ACTIVITY = "LOYALTY_ACTIVITY",
  P2P_PAYMENT = "P2P_PAYMENT",
  LEGACY_P2P_PAYMENT = "LEGACY_P2P_PAYMENT",
  PEERMENTS_PAYMENT = "PEERMENTS_PAYMENT",
  CUSTOMER = "CUSTOMER",
  MERCHANT = "MERCHANT",
  LOAN_TRANSACTION = "LOAN_TRANSACTION",
  FUTURE_LOAN_TRANSACTION = "FUTURE_LOAN_TRANSACTION",
  /** UI_ACCESS - SYNC_VALUES */
  UI_ACCESS = "UI_ACCESS",
  ADDRESS = "ADDRESS",
  PROFILE_ALIAS = "PROFILE_ALIAS",
  APP_MESSAGE = "APP_MESSAGE",
  BALANCE_SNAPSHOT = "BALANCE_SNAPSHOT",
  ISSUED_CARD = "ISSUED_CARD",
  CORE_CUSTOMER = "CORE_CUSTOMER",
  CHECK_DEPOSIT_PROFILE = "CHECK_DEPOSIT_PROFILE",
  /** @deprecated */
  UI_CRYPTO_CURRENCY = "UI_CRYPTO_CURRENCY",
  DEMAND_DEPOSIT_ACCOUNT = "DEMAND_DEPOSIT_ACCOUNT",
  EXCHANGE_DATA = "EXCHANGE_DATA",
  EXPERIMENT = "EXPERIMENT",
  FAMILY_ACCOUNT = "FAMILY_ACCOUNT",
  INSTRUMENT = "INSTRUMENT",
  INVEST_NOTIFICATION_SETTINGS = "INVEST_NOTIFICATION_SETTINGS",
  JURISDICTION_CONFIG = "JURISDICTION_CONFIG",
  LOYALTY_PROFILE = "LOYALTY_PROFILE",
  UI_MARKETING = "UI_MARKETING",
  NOTIFICATION_PREFERENCE = "NOTIFICATION_PREFERENCE",
  P2P_SETTINGS = "P2P_SETTINGS",
  PROFILE_DETAILS = "PROFILE_DETAILS",
  PUBLIC_PROFILE = "PUBLIC_PROFILE",
  PASSWORD_INFO = "PASSWORD_INFO",
  SCHEDULED_PAYMENT = "SCHEDULED_PAYMENT",
  STATUS_AND_LIMITS = "STATUS_AND_LIMITS",
  TAX = "TAX",
  WALLET = "WALLET",
  BANKING_TAB = "BANKING_TAB",
  OTP_INFO = "OTP_INFO",
  BANKING_TRANSACTION = "BANKING_TRANSACTION",
  CRYPTOCURRENCY_PROFILE = "CRYPTOCURRENCY_PROFILE",
  BTC_RECURRING_BUY = "BTC_RECURRING_BUY",
  LIGHTNING_DEPOSIT = "LIGHTNING_DEPOSIT",
  ATM_PICKER = "ATM_PICKER",
  AFTERPAY_SUMMARY = "AFTERPAY_SUMMARY",
  SPECIAL_CUSTOMER = "SPECIAL_CUSTOMER",
  CREDIT_LINE_INSTRUMENT = "CREDIT_LINE_INSTRUMENT",
  LENDING_INFO = "LENDING_INFO",
  CASH_INS = "CASH_INS",
  CASH_OUTS = "CASH_OUTS",
  TRUSTED_CONTACT = "TRUSTED_CONTACT",
  IDV_STATE = "IDV_STATE",
  LIBRARIAN_DOCUMENT_CATEGORY = "LIBRARIAN_DOCUMENT_CATEGORY",
  /** INVESTING_AUTOMATION_CONFIGURATION - go/autoinvest */
  INVESTING_AUTOMATION_CONFIGURATION = "INVESTING_AUTOMATION_CONFIGURATION",
  INVESTING_AUTOMATION_EXECUTION = "INVESTING_AUTOMATION_EXECUTION",
  LOAN = "LOAN",
  FAVORITE = "FAVORITE",
  INVEST_STATE = "INVEST_STATE",
  SAVINGS_HOME = "SAVINGS_HOME",
  SAVINGS_CONFIG = "SAVINGS_CONFIG",
  SAVINGS_FOLDER = "SAVINGS_FOLDER",
  TIGERS = "TIGERS",
  /** REMITTANCE_PAYMENT - an international remittance P2P payment */
  REMITTANCE_PAYMENT = "REMITTANCE_PAYMENT",
  /** REMITTANCE_RECIPIENT - an international remittance P2P recipient, sent as a customer */
  REMITTANCE_RECIPIENT = "REMITTANCE_RECIPIENT",
  /** TAXUPG - status of a customer in the Tax upgrade process */
  TAXUPG = "TAXUPG",
  /** TAXEFI - status of a customer in the Tax efile process */
  TAXEFI = "TAXEFI",
  /** SAVINGS_INTERNAL_TRANSFER - Internal transfer activity */
  SAVINGS_INTERNAL_TRANSFER = "SAVINGS_INTERNAL_TRANSFER",
  CASH_LIMITS = "CASH_LIMITS",
  WIRE_TRANSFER = "WIRE_TRANSFER",
  GROUP_ACTIVITY = "GROUP_ACTIVITY",
  GROUP = "GROUP",
  EXPENSE = "EXPENSE",
  EXPENSE_SLICE = "EXPENSE_SLICE",
  COUPON_ACTIVITIES = "COUPON_ACTIVITIES",
  /** INVEST_CORRECTION - go/nbbo-adjustment */
  INVEST_CORRECTION = "INVEST_CORRECTION",
  INVESTING_DOCUMENT = "INVESTING_DOCUMENT",
  LIONS = "LIONS",
  DEVICE = "DEVICE",
  LIMITS_PAGELET_INLINE_MESSAGE = "LIMITS_PAGELET_INLINE_MESSAGE",
  SYNC_VALUE_SCHEMA_VERSIONS = "SYNC_VALUE_SCHEMA_VERSIONS",
  CATS = "CATS",
  INSTRUMENT_LINKING_OPTION = "INSTRUMENT_LINKING_OPTION",
  RABBITS = "RABBITS",
  OVERDRAFT_STATUS = "OVERDRAFT_STATUS",
  OVERDRAFT_USAGE = "OVERDRAFT_USAGE",
  INSTRUMENT_LINKING_OPTIONS = "INSTRUMENT_LINKING_OPTIONS",
  IDENTITY_HUB_STATE = "IDENTITY_HUB_STATE",
  SPONSORSHIP_CRYPTO_AUTHORIZATION = "SPONSORSHIP_CRYPTO_AUTHORIZATION",
  OFFER_CUSTOMER_PREFERENCE = "OFFER_CUSTOMER_PREFERENCE",
  PASSKEY_OPTIONS = "PASSKEY_OPTIONS",
  PAPER_CASH_DEPOSIT_ELIGIBILITY = "PAPER_CASH_DEPOSIT_ELIGIBILITY",
  CHECK_DEPOSIT_ELIGIBILITY = "CHECK_DEPOSIT_ELIGIBILITY",
  REACTIONS = "REACTIONS",
  /** PAYCHECKS_ALLOCATION_DISTRIBUTION - see go/$paychecks */
  PAYCHECKS_ALLOCATION_DISTRIBUTION = "PAYCHECKS_ALLOCATION_DISTRIBUTION",
  PAYCHECKS_UI_CONFIGURATION = "PAYCHECKS_UI_CONFIGURATION",
  PAYCHECKS_UI_STATE = "PAYCHECKS_UI_STATE",
  WIRES_ELIGIBILITY_STATE = "WIRES_ELIGIBILITY_STATE",
  SPONSORSHIP_FEATURE_INVITATION = "SPONSORSHIP_FEATURE_INVITATION",
  OVERDRAFT_TRANSACTION = "OVERDRAFT_TRANSACTION",
  C4B_PROFILE = "C4B_PROFILE",
  REACTIONS_AVAILABLE = "REACTIONS_AVAILABLE",
  TTP_PAYMENT = "TTP_PAYMENT",
  BORROW_CONFIG = "BORROW_CONFIG",
  GLOBAL_BORROW_CONFIG = "GLOBAL_BORROW_CONFIG",
  BORROW_APPLET_CREDIT_AND_BORROW_TILE = "BORROW_APPLET_CREDIT_AND_BORROW_TILE",
  BORROW_APPLET_PAYMENT_TIMELINE_TILE = "BORROW_APPLET_PAYMENT_TIMELINE_TILE",
  BORROW_APPLET_BULLETINS_TILE = "BORROW_APPLET_BULLETINS_TILE",
  INTERNATIONAL_PAYMENT_CONFIG = "INTERNATIONAL_PAYMENT_CONFIG",
}
